export const Terms = () => (
    <div className="container">
        <div className="row">
            <div className="col-12">
                Hello
            </div>
        </div>
    </div>
)